<template>
  <div class="upload-item-materials" v-if="showPage">
    <!-- 驳回提示 -->
    <div class="upload-status" v-if="checkItem.result.status=='审核不通过'" >
      <div class="status"><img width="16px" style="margin-right:4px;" src="/static/upload/refuseIcon.png" />{{checkItem.result.status}}</div>
      <div class="reason">驳回原因：{{checkItem.result.reasons}}</div>
    </div>

    <!-- 上传图片 -->
    <div class="shadow-box">
      <image-uploader ref="imgUploader" :title="checkItem.name" :value="images"  :history="checkItem.attach"
        :temp="checkItem.image"  :words="checkItem.words" ></image-uploader>
    </div>

    <!-- 按钮组 -->
    <div class="btn">
      <van-button type="default" class="btn1" plain round @click="back()" color="#0AA8AF">
      返回</van-button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {
    UploadCheckItem,
    GetCheckItem,
    FollowUpload,
    UploadRecipel
  } from '../../api/api'
  import {
    Toast,
    ImagePreview,
    Dialog,
    Uploader
  } from 'vant'
  import {
    mapState
  } from "vuex";
  import ImageUploader from "@/views/apply/ImageUploader2";
  
  Vue.use(Toast)
  Vue.use(ImagePreview)
  Vue.use(Dialog)
  Vue.use(Uploader)

  export default {
    name: "materials",
    components: {
      ImageUploader
    },
    data() {
      return {
        papid: '',
        patient_id: '',
        check_item_id: '',
        category: '',
        follow: false,
        images: [],
        checkItem: {
          name: '',
          attach: [],
          image: ''
        },
        disabled: false,
        showPage:false,
      };
    },
    computed: {
      ...mapState(['userInfo','patientInfo','patientOne']),
    },
    async created() {
      this.papid = this.$route.query.papid;
      this.check_item_id = this.$route.query.id;
      this.category = this.$route.query.category;
      this.active = this.$route.query.active;
      this.follow = this.$route.query.follow;
      if (this.userInfo.patient) {
        this.patient_id = this.userInfo.patient.id
      }
      // console.log(this.category, this.$route.query, 'num:', this.num)
      await this.getData()
    },
    methods: {
      async getData() {
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true
        });
        let ci = await GetCheckItem({
          papid: this.papid,
          category: this.category,
          check_item_id: this.check_item_id
        })
        this.checkItem = ci.data
        this.showPage=true;
        //获取到数据后再展示页面
        console.log("this.checkItem",this.checkItem)

        Toast.clear()
      },
      submitUpload() {
        if (this.checkItem.attach.length == 0 && this.images.length == 0) {
          Toast("材料未上传");
          return;
        }
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          overlay: true
        });
        this.nextBtnDisabled = true
        let ci = []
        this.images.forEach(ele => {
          ci.push(ele.src)
        });
        if (this.category == '后续复核') {
          FollowUpload({
            papid: this.papid,
            check_items: ci,
            category: this.category,
            check_item_id: this.check_item_id
          }).then((res) => {
            this.nextBtnDisabled = false
            if (res.data) {
              this.$router.replace({
                name: "Upload",
                query: {
                  active: this.active,
                  category: this.category
                }
              })
              Toast({
                message: "材料上传成功",
                duration: 1000
              });
            }
            Toast.clear()
          }).catch((err) => {
            this.nextBtnDisabled = false
            Toast.clear()
            Toast(err.response.data.message)
          })
          return
        } else {
          UploadCheckItem({
            papid: this.papid,
            check_items: ci,
            category: this.category,
            check_item_id: this.check_item_id
          }).then((res) => {
            this.nextBtnDisabled = false
            if (res.data) {
              this.$router.replace({
                name: "Upload",
                query: {
                  active: this.active,
                  category: this.category
                }
              })
              Toast({
                message: "材料上传成功",
                duration: 1000
              });
            }
            Toast.clear()
          }).catch((err) => {
            this.nextBtnDisabled = false
            Toast.clear()
            Toast(err.response.data.message)
          })
        }
      },
      back() {
          this.$router.push({name:"MailPaperMaterials"})
      },
    },
  };
</script>

<style lang="less">
  .upload-item-materials {
    min-height: 100vh;
    padding-TOP: 2px;
    box-sizing: border-box;
    .shadow-box{
      margin-bottom: 50px;
    }
    .myuploader {
      background: #fff;
    }

    .upload-status {
      box-sizing: border-box;
      padding: 10px 15px;
      margin: 16px;
      border-radius: 10px;
      overflow: hidden;
      background-color: #FFDADB;
      font-size: 14px;
      color:#FF4830;
      .status{
        display: flex;
        align-items: center;
      }
      .reason{}
      &.red {
        color: @red;
      }
    }

    .btn{
      display: flex;
      justify-content:space-between;
      width: 100%;
      padding: 10px;
      // background-color: white;
      margin: 0;
      .van-button{
        margin: 0 5px;
        white-space: nowrap;
      }
      .btn1{flex-grow: 1;}
      .btn2{flex-grow: 4;}
    }
  }
</style>